import { action } from 'mobx';
import i18next from 'i18next';

import { AppManager } from 'core/index';

import { ProfileConnManager } from 'apps/profile/main/connManager';
import { CommunityProfilesQuery } from 'apps/profile/gql';

export default class CommunityMembersManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.profilesConn = new ProfileConnManager(this, {
      sortBy: 'recent',
      initialBatchSize: 20,
      batchSize: 16,
      sortOptions: [
        ['recent', i18next.t('Recent')],
        ['followers', i18next.t('Followers')],
      ],
      loadMoreQuery: CommunityProfilesQuery,
    });
    this.CommunityQuery();
  }

  @action CommunityQuery = () => {
    this.profilesConn.loadMore();
  };
}
